import React, { useState } from "react";
import { Confirm, useRefresh, useTranslate } from "react-admin";
import {
  TenantRegistrationApiFactory,
  TenantRegistrationDto,
  TenantRegistrationStatus,
} from "../../../common/data/service-proxies";
import {
  ListItemIcon,
  ListItemText,
  makeStyles,
  MenuItem,
  Theme,
} from "@material-ui/core";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";

interface Props {
  label: string;
  icon: JSX.Element;
  record?: TenantRegistrationDto;
  resource?: string;
  confirmTitle?: string;
  confirmContent?: string;
  onClick?: (event: React.MouseEvent) => void;
  hidden?: boolean | ((record: TenantRegistrationDto) => boolean);
  status?: TenantRegistrationStatus;
}

const isBoolean = (
  input?: boolean | ((record: TenantRegistrationDto) => boolean)
): input is boolean => {
  return input === true || input === false;
};

const useRejectStyles = makeStyles((theme: Theme) => ({
  approve: {
    color: theme.palette.error.main,
  },
}));

export const DeleteRegistrationMenuItem = (props: Props) => {
  const {
    record,
    resource,
    onClick,
    hidden,
    label,
    icon,
    status,
    confirmTitle,
    confirmContent,
    ...rest
  } = props;
  const refresh = useRefresh();
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const translate = useTranslate();
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();
  const rejectClasses = useRejectStyles();

  if (!record) {
    return null;
  }

  if (!resource) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleDelete = () => {
    if (!axios) {
      return;
    }

    setLoading(true);
    TenantRegistrationApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppTenantregistrationIdDelete(record.id!)
      .then(() => {
        refresh();
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}
      >
        <ListItemIcon className={rejectClasses.approve}>{icon}</ListItemIcon>
        <ListItemText>{translate(label, { _: label })}</ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isConfirmOpen}
        loading={loading}
        title={confirmTitle ?? "Delete"}
        content={confirmContent}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
